module.exports = __webpack_public_path__ + "admin-thumbs/v-cta.png";